import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	next_page, setPasswordError, setLoading, updateToken
} from '../actions';
import { updateUserInformation } from '../general-functions';
import LoadingButton from './loading-button';
import '../global';

class NextButton extends Component {

	handleClick() {
		this.props.setLoading( true );
		if ( this.props.currentPage === 'user-information' ) {
			let clScope = this;
			updateUserInformation( this.props.userInfo ).then( function( response ) {
				if ( response.LoginUserResult === 'Succeeded' ) {
					clScope.props.next_page( clScope.props.currentPage );
					clScope.props.updateToken( response.token );
				} else {
					const errorMessage = response.errors.imis_password[ 0 ];
					clScope.props.setLoading( false );
					clScope.props.setPasswordError( errorMessage );

				}
			} );
		} else {
			this.props.next_page( this.props.currentPage );
		}

	}

	render() {
		let className = '';
		if ( typeof this.props.gtm_class !== 'undefined' ) {
			className = this.props.gtm_class;
		}
		if ( this.props.isLoading === true ) {
			return (
				<div className="button-container"><LoadingButton /></div>
			);
		} else {
			return (
				<div className="button-container">
					<button className={ 'btn btn-default ' + className } data-party-id={ getPartyID() } onClick={ this.handleClick.bind( this ) }>Next</button>
				</div>
			);
		}

	}

}

function mapStateToProps( { currentPage, userInfo, isLoading } ) {
	return {
		currentPage, userInfo, isLoading
	};
}

export default connect( mapStateToProps, {
	next_page,
	setPasswordError,
	setLoading,
	updateToken
} )( NextButton );